import React from 'react';
import adjust from './icons/adjust.svg';
// Icons
import angleDoubleDown from './icons/angle-double-down.svg';
import angleDoubleUp from './icons/angle-double-up.svg';
import angleLeft from './icons/angle-left.svg';
import arrows from './icons/arrows.svg';
import arrowsAltH from './icons/arrows-alt-h.svg';
import arrowsAltV from './icons/arrows-alt-v.svg';
import arrowRight from './icons/arrow-right.svg';
import arrowDownRight from './icons/arrow-down-right.svg';
import autoCircle from './icons/auto-circle.svg';
import autoActivityZone from './icons/auto-activity-zone.svg';
import autoAwesome from './icons/auto-awesome.svg';
import autoFixHigh from './icons/auto-fix-high.svg';
import autoFixNormal from './icons/auto-fix-normal.svg';
import magic from './icons/magic-button.svg';
import bars from './icons/bars.svg';
import brain from './icons/brain.svg';
import brush from './icons/brush.svg';
import caretDown from './icons/caret-down.svg';
import caretUp from './icons/caret-up.svg';
import check from './icons/check.svg';
import checkCircle from './icons/check-circle.svg';
import checkCircleO from './icons/check-circle-o.svg';
import chevronDown from './icons/chevron-down.svg';
import featherChevronDown from './icons/feather-chevron-down.svg';
import featherChevronRight from './icons/feather-chevron-right.svg';
import circle from './icons/circle.svg';
import circleNotch from './icons/circle-notch.svg';
import circleO from './icons/circle-o.svg';
import cog from './icons/cog.svg';
import copy from './icons/copy.svg';
import code from './icons/code.svg';
import coor from './icons/coor-with-model.svg';
import cornerRightUp from './icons/corner-right-up.svg';
import clipboard from './icons/clipboard.svg';
import createComment from './icons/create-comment.svg';
import createScreenCapture from './icons/create-screen-capture.svg';
import crosshairs from './icons/crosshairs.svg';
import crosshair from './icons/crosshair.svg';
import cube from './icons/cube.svg';
import d3Rotate from './icons/3d-rotate.svg';
import database from './icons/database.svg';
import deleteSweep from './icons/delete_sweep.svg';
import dotCircle from './icons/dot-circle.svg';
import edit from './icons/edit.svg';
import editLight from './icons/edit-2.svg';
import ellipseCircle from './icons/ellipse-circle.svg';
import ellipseH from './icons/ellipse-h.svg';
import ellipseV from './icons/ellipse-v.svg';
import eraserFill from './icons/eraser-fill.svg';
import exclamationCircle from './icons/exclamation-circle.svg';
import exclamationTriangle from './icons/exclamation-triangle.svg';
import fastBackward from './icons/fast-backward.svg';
import fastForward from './icons/fast-forward.svg';
import stop from './icons/stop.svg';
import info from './icons/info.svg';
import featherInfo from './icons/feather-info.svg';
import inlineEdit from './icons/inline-edit.svg';
import level from './icons/level.svg';
import link from './icons/link.svg';
import linkCircles from './icons/link-circles.svg';
import list from './icons/list.svg';
import liver from './icons/liver.svg';
import lock from './icons/lock.svg';
import featherLock from './icons/feather-lock.svg';
import featherUnlock from './icons/feather-unlock.svg';
import lockAlt from './icons/lock-alt.svg';
import lung from './icons/lung.svg';
import measureNonTarget from './icons/measure-non-target.svg';
import measureTarget from './icons/measure-target.svg';
import measureTargetCr from './icons/measure-target-cr.svg';
import measureTargetNe from './icons/measure-target-ne.svg';
import measureTargetUn from './icons/measure-target-un.svg';
import measureTemp from './icons/measure-temp.svg';
import navigation from './icons/navigation.svg';
import menu from './icons/menu.svg';
import monitor from './icons/monitor.svg';
import objectGroup from './icons/object-group.svg';
import oval from './icons/oval.svg';
import palette from './icons/palette.svg';
import play from './icons/play.svg';
import plus from './icons/plus.svg';
import powerOff from './icons/power-off.svg';
import reset from './icons/reset.svg';
import rotate from './icons/rotate.svg';
import rotateRight from './icons/rotate-right.svg';
import saveRegular from './icons/save-regular.svg';
import scissors from './icons/scissors.svg';
import search from './icons/search.svg';
import searchPlus from './icons/search-plus.svg';
import settings from './icons/settings.svg';
import sliders from './icons/sliders.svg';
import softTissue from './icons/soft-tissue.svg';
import sort from './icons/sort.svg';
import sortDown from './icons/sort-down.svg';
import sortUp from './icons/sort-up.svg';
import sphere from './icons/sphere.svg';
import userCheck from './icons/user-check.svg';
import checkSquare from './icons/check-square.svg';
import square from './icons/square.svg';
import squareO from './icons/square-o.svg';
import star from './icons/star.svg';
import stepBackward from './icons/step-backward.svg';
import stepForward from './icons/step-forward.svg';
import sun from './icons/sun.svg';
import th from './icons/th.svg';
import thLarge from './icons/th-large.svg';
import thList from './icons/th-list.svg';
import times from './icons/times.svg';
import trash from './icons/trash.svg';
import trashLight from './icons/trash-2.svg';
import unlink from './icons/unlink.svg';
import user from './icons/user.svg';
import personFill from './icons/person-fill.svg';
import warning from './icons/warning.svg';
import youtube from './icons/youtube.svg';
import eye from './icons/eye.svg';
import eyeClosed from './icons/eye-closed.svg';
import eyeOn from './icons/eye-on.svg';
import eyeOff from './icons/eye-off.svg';
import booleanOperation from './icons/boolean.svg';
import booleanUnion from './icons/boolean-union.svg';
import booleanExclude from './icons/boolean-exclude.svg';
import booleanSubtract from './icons/boolean-subtract.svg';
import booleanIntersect from './icons/boolean-intersect.svg';
import triangle from './icons/triangle.svg';
import alertTriangle from './icons/alert-triangle.svg';
import selectAll from './icons/select-all.svg';
import selectAll3D from './icons/select-all-3d.svg';
import webTraffic from './icons/web-traffic.svg';
import developerBoard from './icons/developer-board.svg';
import networkIntelligence from './icons/network-intelligence-update.svg';
import cancel from './icons/cancel-circle.svg';

const ICONS = {
  eye,
  'eye-closed': eyeClosed,
  'eye-on': eyeOn,
  'eye-off': eyeOff,
  brush,
  scissors,
  user,
  'person-fill': personFill,
  sort,
  th,
  star,
  'sort-up': sortUp,
  sphere,
  'sort-down': sortDown,
  info,
  'feather-info': featherInfo,
  cube,
  crosshairs,
  crosshair,
  coor,
  'delete-sweep': deleteSweep,
  'dot-circle': dotCircle,
  'angle-left': angleLeft,
  '3d-rotate': d3Rotate,
  plus,
  'chevron-down': chevronDown,
  'feather-chevron-down': featherChevronDown,
  'feather-chevron-right': featherChevronRight,
  'angle-double-down': angleDoubleDown,
  'angle-double-up': angleDoubleUp,
  'arrows-alt-h': arrowsAltH,
  'arrows-alt-v': arrowsAltV,
  'arrow-right': arrowRight,
  'arrow-down-right': arrowDownRight,
  'auto-circle': autoCircle,
  'auto-activity-zone': autoActivityZone,
  'auto-awesome': autoAwesome,
  'auto-fix-normal': autoFixNormal,
  'auto-fix-high': autoFixHigh,
  magic,
  bars,
  'caret-down': caretDown,
  'caret-up': caretUp,
  'check-circle-o': checkCircleO,
  check,
  circle,
  'circle-o': circleO,
  copy,
  code,
  clipboard,
  'corner-right-up': cornerRightUp,
  times,
  'create-comment': createComment,
  'create-screen-capture': createScreenCapture,
  edit,
  'edit-light': editLight,
  'fast-backward': fastBackward,
  'fast-forward': fastForward,
  'object-group': objectGroup,
  search,
  'power-off': powerOff,
  'inline-edit': inlineEdit,
  list,
  lock,
  'feather-lock': featherLock,
  'feather-unlock': featherUnlock,
  play,
  database,
  cog,
  'circle-notch': circleNotch,
  'feather-check-square': checkSquare,
  'feather-square': square,
  'feather-user-check': userCheck,
  'square-o': squareO,
  'check-circle': checkCircle,
  'lock-alt': lockAlt,
  'step-backward': stepBackward,
  'step-forward': stepForward,
  stop,
  'th-large': thLarge,
  'th-list': thList,
  sun,
  palette,
  youtube,
  oval,
  'ellipse-h': ellipseH,
  'ellipse-v': ellipseV,
  adjust,
  level,
  'link-circles': linkCircles,
  'search-plus': searchPlus,
  'measure-non-target': measureNonTarget,
  'measure-target': measureTarget,
  'measure-target-cr': measureTargetCr,
  'measure-target-un': measureTargetUn,
  'measure-target-ne': measureTargetNe,
  'measure-temp': measureTemp,
  'eraser-fill': eraserFill,
  navigation,
  menu,
  monitor,
  'ellipse-circle': ellipseCircle,
  arrows,
  reset,
  rotate,
  'rotate-right': rotateRight,
  trash,
  'trash-light': trashLight,
  unlink,
  'exclamation-circle': exclamationCircle,
  link,
  'exclamation-triangle': exclamationTriangle,
  brain,
  'soft-tissue': softTissue,
  lung,
  liver,
  save: saveRegular,
  settings,
  sliders,
  'boolean-operation': booleanOperation,
  'boolean-exclude': booleanExclude,
  'boolean-subtract': booleanSubtract,
  'boolean-union': booleanUnion,
  'boolean-intersect': booleanIntersect,
  warning,
  triangle,
  'alert-triangle': alertTriangle,
  'web-traffic': webTraffic,
  'select-all': selectAll,
  'select-all-3d': selectAll3D,
  'developer-board': developerBoard,
  'network-intelligence': networkIntelligence,
  cancel,
};

/**
 * Return the matching SVG Icon as a React Component.
 * Results in an inlined SVG Element. If there's no match,
 * return `null`
 */
export default function getIcon(key, props) {
  if (!key || !ICONS[key]) {
    return React.createElement('div', null, 'Missing Icon');
  }

  return React.createElement(ICONS[key], props);
}

export { ICONS };
